<script setup lang="ts">
import { ZFeedbackPage } from '@zoomcatalog/design-system';

const locale = {
  DESIGN_PRIVATE_TITLE: 'This design is private',
  DESIGN_PRIVATE_TEXT:
    'The person who shared this designed marked it as private. Login or make the design public to see it.',
};
</script>

<template>
  <ZFeedbackPage>
    <template #title>
      {{ locale.DESIGN_PRIVATE_TITLE }}
    </template>
    <template #description>
      {{ locale.DESIGN_PRIVATE_TEXT }}
    </template>
  </ZFeedbackPage>
</template>
